import axios, { AxiosError } from 'axios'
//import { useErrorStore } from '../stores/errorStore'
//import { isDev } from './utils'

const httpClient = axios.create({
  baseURL: (window.APP_CONFIG?.API_BASE_URL || import.meta.env.VITE_API_BASE_URL) + '/api/',
  withCredentials: true, // send cookies
  headers: {
    'Content-Type': 'application/json',
    'x-platform-api-auth': window.APP_CONFIG?.API_AUTH_KEY || '',
  },
})

// Response Interceptor: handle 401 globally
httpClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    //const errorStore = useErrorStore()
    const message = `AxiosError: ${error.message} | code=${error.code} | url=${error.config?.url} | status=${error
      .response?.status} | data=${JSON.stringify(error.response?.data)}`
    console.error(message)
    //errorStore.setErrors([message])
    return Promise.reject(error)
  },
)

export default httpClient
